var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Agence Flaxeo : Création de site e-commerce Magento, développements web")]),_c('HomeSlider'),_c('Verticalsep'),_c('HomeStaticBlock'),_c('Verticalsep'),_c('HomeTechnos'),_c('HomeReference')],1)}
var staticRenderFns = []

export { render, staticRenderFns }